import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface MenuItem {
  path: string;
  label: string;
  icon: string;
}

const menuItems: MenuItem[] = [
  { path: '/dashboard', label: 'Dashboard', icon: '📊' },
  { path: '/backfill', label: 'Backfill', icon: '⏮️' },
  { path: '/gaps', label: 'Gaps', icon: '🔍' },
  { path: '/betaspread', label: 'BetaSpread', icon: '📈' },
  { path: '/strategies', label: 'Strategies', icon: '📡' },
  { path: '/symbols', label: 'Symbols', icon: '⚙️' },
  { path: '/health', label: 'Health', icon: '❤️' },
];

export const Sidebar: React.FC = () => {
  const location = useLocation();

  return (
    <div style={{
      width: '250px',
      height: '100vh',
      backgroundColor: '#1e293b',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      left: 0,
      top: 0,
      borderRight: '1px solid #334155'
    }}>
      {/* Logo Section */}
      <div style={{
        padding: '20px',
        borderBottom: '1px solid #334155'
      }}>
        <h1 style={{
          margin: 0,
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#3b82f6'
        }}>
          ◉→◉→◉
        </h1>
        <p style={{
          margin: '5px 0 0 0',
          fontSize: '14px',
          color: '#94a3b8'
        }}>
          QuantXFeed Admin
        </p>
      </div>

      {/* Navigation Menu */}
      <nav style={{ flex: 1, padding: '20px 0' }}>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 20px',
                textDecoration: 'none',
                color: isActive ? '#3b82f6' : '#94a3b8',
                backgroundColor: isActive ? '#334155' : 'transparent',
                borderLeft: isActive ? '4px solid #3b82f6' : '4px solid transparent',
                transition: 'all 0.2s',
                fontSize: '16px'
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = '#334155';
                  e.currentTarget.style.color = 'white';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#94a3b8';
                }
              }}
            >
              <span style={{ marginRight: '12px', fontSize: '20px' }}>
                {item.icon}
              </span>
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div style={{
        padding: '20px',
        borderTop: '1px solid #334155',
        fontSize: '12px',
        color: '#64748b',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0 }}>DataFeed Server v1.0</p>
        <p style={{ margin: '5px 0 0 0' }}>Independent Auth</p>
      </div>
    </div>
  );
};
